module.exports = __webpack_public_path__ + "static/img/bx2.d33421be.png";